import React from "react";

export const Arrow120 = ({ size = 18, className = "" }) => (
  <span className={`arrow-120 ${className}`} aria-hidden>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  </span>
);

export default Arrow120;
